import React, { Fragment, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

export const FormErrorSuccessMsg = (props: {
  message: string | null;
  success: boolean;
  duration?: number;
}) => {
  const [visible, setVisible] = useState(true);

  //   useEffect(() => {
  //     const duration = props.duration;
  //     const timer = setTimeout(() => {
  //       setVisible(false);
  //     }, duration);

  //     return () => clearTimeout(timer);
  //   }, [props.message, props.success, props.duration]);

  //   if (!visible) return null;

  return (
    <Fragment>
      {props?.success ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            bgcolor: "#D4EDDA",
            marginTop: "12px",
            marginBottom: "12px",
            color: "#4CAF50",
            padding: "16px",
            borderRadius: "10px",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              wordBreak: "keep-all",
              whiteSpace: "pre-line",
              alignItems: "center",
              fontWeight: 500,
            }}
          >
            {props.message}
          </Typography>
        </Box>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            bgcolor: "#FFC5C5",
            marginBottom: "12px",
            marginTop: "12px",
            color: "#C90000",
            padding: "16px",
            borderRadius: "10px",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              wordBreak: "keep-all",
              whiteSpace: "pre-line",
              alignItems: "center",
            }}
          >
            {props.message}
          </Typography>
        </Box>
      )}
    </Fragment>
  );
};
export default FormErrorSuccessMsg;
